import React from "react";
import clsx from "clsx";

export function Loader({ size = "default" }: { size?: "sm" | "default" }) {
  return (
    <>
      <span
        className={clsx("live-timetable__loader", {
          "live-timetable__loader--small": size === "sm",
        })}
      ></span>
      <span className="readers-only">Loading...</span>
    </>
  );
}
